import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import CreateProtocolTemplate from './CreateProtocolTemplate.js';

export default WithGASetup(CreateProtocolTemplate, AuthContext);
